<div class="empty">
    <div
        class="empty__animation"
        [style.width]="animationWidth()"
        [style.height]="animationHeight()"
        #lottieContainer></div>

    <div class="empty__text">
        <h3 class="empty__title">{{ title() }}</h3>
        @if (description()) {
            <p class="empty__description">{{ description() }}</p>
        }
    </div>
</div>
